<template>
    <el-button type="primary" :size="size" @click="open" :disabled="ids.length < 1">
        <i class="fa fa-eyedropper"></i>&nbsp;<slot></slot>
    </el-button>
</template>
<script>
    /**
     * 批量备注
     * @author zjs
     * @time 2018-05-17
     */
    export default {
        name: "LyButtonRemark",
        props: {
            api: String, // 备注提交的地址
            rows: { // 要备注列的数据集合
                type: Array,
                default: () => []
            },            
            size: {
                type: String,
                default: 'small'
            }
        },
        computed: {
            ids () {
                let id = []
                this.rows.forEach((el) => {
                    if (el.id) {
                        id.push(el.id)
                    }
                })
                return id
            }
        },
        methods: {
            open () {
                this.$prompt('请输入备注', '批量备注', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue: "暂不处理",
                    inputPattern: /^.{2,1000}$/,
                    inputErrorMessage: '请输入备注内容'
                }).then(({value}) => {
                    this.submitRemark(value)
                })
                console.log('this.$el:%O', this.$el)
            },
            /**
             * 提交备注
             */
            submitRemark (remark) {
                this.$api.create(this.api, {
                    ids: this.ids,
                    remark: remark
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '批量备注完成'
                    })
                }).catch((msg) => {
                    this.$message({
                        type: 'warning',
                        message: msg
                    })
                })
            }
        }
    }
</script>